<template>
  <v-dialog v-model="showDiscountDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <DiscountForm
          :errors="violations"
          :values="item"
          :loading="isLoading"
          ref="discountDialogForm"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="showDiscountDialog = false">{{ $t('Close') }}</v-btn>
        <v-spacer/>
        <v-btn class="mainAccent lighten-3" dark @click="resetForm">{{ $t('Reset') }}</v-btn>
        <v-btn color="primary" @click="sendForm">{{ $t('Submit') }}</v-btn>
      </v-card-actions>
    </v-card>
    <Loading :visible="isLoading"/>
  </v-dialog>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import DiscountForm from './Form';
import NotificationMixin from '../../mixins/NotificationMixin';
import Loading from "@/components/Loading";
import {mapActions, mapGetters} from "vuex";

const servicePrefix = 'Discount';

export default {
  name: "DiscountDialog",
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    DiscountForm
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      required: true
    },
    handleCreated: {
      type: Function,
      required: false
    },
    handleUpdated: {
      type: Function,
      required: false
    },
    discountItem: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      item: {},
      createMessage: this.$t("successfullyCreated"),
      updateMessage: this.$t("successfullyUpdated"),
    }
  },
  computed: {
    ...mapFields('discount', ['error', 'isLoading', 'created', 'violations', 'updated', 'byId']),
    ...mapGetters('discount', ['find']),
    showDiscountDialog: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },
  methods: {
    ...mapActions('discount', {
      create: 'create',
      update: 'update',
      resetData: 'resetData',
      retrieve: 'load'
    }),
    sendForm() {
      if (this.isValidForm()) {
        let model = this.$refs.discountDialogForm.$v.item.$model;
        if (this.handleUpdated && model['@id']) {
          this.update(model);
        }
        if (this.handleCreated && !model['@id']) {
          this.create(model);
        }
      }
    },
    reset() {
      this.$refs.discountDialogForm.$v.$reset();
    },
    resetForm() {
      this.item = {...this.discountItem};
      if (this.$refs['discountDialogForm']) {
        this.$refs.discountDialogForm.$v.$reset();
      }
    },
    isValidForm() {
      this.$refs.discountDialogForm.$v.$touch();
      return !this.$refs.discountDialogForm.$v.$invalid;
    },
  },
  watch: {
    discountItem() {
      this.item = {...this.discountItem};
      this.resetForm();
    },
    created(created) {
      if (!created) {
        return;
      }
      this.showMessage(this.createMessage);
      if (this.handleCreated) {
        this.handleCreated(this.created);
        this.showDiscountDialog = false;
      }
    },
    updated() {
      this.showMessage(this.updateMessage);
      if (this.handleUpdated) {
        this.handleUpdated(this.updated);
        this.showDiscountDialog = false
      }
    },
    error(message) {
      message && this.showError(message);
    },
  },
  created() {
    this.item = {...this.discountItem};
  }
}
</script>
